import "./input.css";
import "./dropdown.css";
import { useEffect, useRef, useState } from "react";
import { inputFunc } from "../../lib/inputFunctions";
import CheckBox from "./CheckBox";

type TextInputProps = {
  state: { [key: string]: any };
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
  stateKey: string;
  list: { [key: string]: any }[];
  listKeys: string[];
  label?: string;
  inlineLabel?: string;
  labelWidth?: number;
  placeholder?: string;
  required?: boolean;
};

export function MultiSelect({
  state,
  stateKey,
  setState,
  list = [],
  listKeys,
  label,
  inlineLabel,
  labelWidth,
  placeholder,
  required,
}: TextInputProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [active, setActive] = useState(false);

  const onClickItem = (value: string) => {
    const id = value.toString();
    if (!state[stateKey]) {
      setState((prev) => ({
        ...prev,
        [stateKey]: [id],
      }));
    } else {
      state[stateKey].includes(id)
        ? setState((prev) => ({
            ...prev,
            [stateKey]: prev[stateKey].filter((i: any) => i !== id),
          }))
        : setState((prev) => ({
            ...prev,
            [stateKey]: [...prev[stateKey], id],
          }));
    }
  };

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="input-container dropdown">
      {label && (
        <div className="input-label">
          <label>{label}</label>
        </div>
      )}
      <div className="input-wrapper">
        {inlineLabel && (
          <div style={{ width: labelWidth }} className="input-inline-label">
            {inlineLabel}
          </div>
        )}
        <div className="inputfield-wrapper">
          <input
            id={stateKey}
            name={stateKey}
            value={state[stateKey] && state[stateKey].length > 0 ? `${state[stateKey].length} kiválasztva` : ``}
            className={`inputfield ${inlineLabel && "inlinelabeled"}`}
            type="text"
            placeholder={placeholder}
            required={required}
            readOnly
            onClick={() => setActive(active ? false : true)}
          />
        </div>
        {state[stateKey] && state[stateKey].length !== 0 && (
          <div className="input-delete" onClick={() => inputFunc.changeObj([], setState, stateKey)}>
            {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="18px"
                viewBox="0 -960 960 960"
                width="18px"
                fill="#e3e3e3">
                <path d="M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z" />
              </svg>
            }
          </div>
        )}
        <div className="input-after" onClick={() => setActive(active ? false : true)}>
          {
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
              <path d="M480-360 280-560h400L480-360Z" />
            </svg>
          }
        </div>
      </div>
      {list.length > 0 && (
        <div className={`dropdown-menu ${active ? "open" : ""}`}>
          {list.map((item: any, index: number) => (
            <div
              key={index}
              className={`dropdown-item ${state[stateKey]?.includes(item.id.toString()) && "selected"}`}
              onClick={() => {
                onClickItem(item.id);
              }}>
              {listKeys.map((e, i) => (
                <div key={i} style={{ display: "inline-block", marginRight: 5 }}>
                  {item[e]}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
